export type IconSize = keyof typeof IconSizes

export enum IconSizes {
  xxs = '12px',
  sm = '16px',
  md = '18px',
  lg = '20px',
  xl = '24px',
}
